<template>
  <div class="server-card-wrapper" v-r-loading="itemLoading">
    <div class="card-item" v-for="(item, index) in list" :key="'item' + index">
      <img
        class="item-img"
        v-if="item.headPic"
        :src="item.headPic"
        v-http2
        v-img-size="'medium'"
        v-img-error
      />
      <div class="content-box">
        <p class="item-title ellipsis" v-text="item.name"></p>
        <p class="item-tag ellipsis" v-text="item.tag"></p>
      </div>
      <div class="mb-right-box">
        <!-- <p class="msg-btn" v-if="item.isOpenIm" @click="goMsgIM(item)"><i class="icon-outlined_message"></i></p> -->
        <p class="phone-btn" v-if="item.isOpenPhone" @click="callPhone(item)">
          <i class="icon-outline_phone"></i>
        </p>
      </div>
      <PhoneCard
        :show="phoneCardShow(item)"
        :title="phoneMap.title"
        :phone="phoneMap.phone"
      >
        <div
          class="mask-opacity"
          v-if="!isH5"
          @click="cardClick(item)"
          @mouseleave="mouseleave"
        ></div>
      </PhoneCard>
    </div>
  </div>
</template>
<script>
import { mapState } from 'vuex';
import { Encrypt, Decrypt } from '@/utils/crypto';
import PhoneCard from './phoneCard.vue';
import api from '@/api';
import { ORDER_DETAIL_REFRESH, eventBus } from '@/utils/eventBus';

export default {
  name: 'ServerCard',
  components: {
    PhoneCard,
  },
  props: {
    list: Array,
    orderId: String,
    orderStatus: Number,
  },
  computed: {
    ...mapState({
      isH5: ({ common }) => common.isH5,
      sidebar: ({ common }) => common.sidebar,
    }),
    phone() {
      return this.sidebar?.selfInfo?.phone;
    },
    callingCode() {
      return this.sidebar?.selfInfo?.callingCode;
    },
  },
  watch: {
    orderId(nVal, oVal) {
      if (nVal !== oVal) {
        this.initData();
      }
    }
  },
  data() {
    return {
      detailData: null,
      itemLoading: false,
      showMask: false,
      phoneMap: {},
      virtualPhone: {
        1: {
          type: 1,
          showMask: false,
          title: '',
          phone: '',
          protected: false,
          isLoad: false,
        },
        2: {},
      },
    };
  },
  mounted() {
    this.initData();
    eventBus.$on(ORDER_DETAIL_REFRESH, () => {
      this.initData();
    })
  },
  methods: {
    async initData() {
      this.phoneMap = {}
      // 独有逻辑 从旧的详情接口获取 电话相关信息 新接口没有 如果有了请改造这里
      let data = await api.orderDetailBatch({
        orderIds: this.orderId,
      });
      data = data.orders[0]
      this.detailData = data
      // shopInfo callPhone 商家号码 callPhoneProtected 1 号码保护
      // deliveryInfo riderPhone 骑手号码 riderPhoneProtected 1 号码保护
      if (data) {
        this.virtualPhone[1] = {
          type: 1,
          showMask: false,
          title: `${this.$t('呼叫')} ${data?.shopInfo?.shopName}`,
          phone: data?.shopInfo?.phone, // oriCallPhone
          protected: data?.shopInfo?.callPhoneProtected,
          isLoad: false,
        };
        this.virtualPhone[2] = {
          type: 2,
          showMask: false,
          title: data?.shopInfo?.riderName,
          phone: data?.deliveryInfo?.riderPhone,
          protected: data?.deliveryInfo?.riderPhoneProtected,
          isLoad: false,
        };
      }
    },
    goMsgIM(item) {
      // 功能暂时没有？？？
      if (!item.isOpenIm) return;
    },
    cardClick(item, fn) {
      if (!item.isOpenPhone) return;
      if (this?.phoneMap?.showMask) {
        this.phoneMap.showMask = false;
        if (this.phoneMap.type === +item.type) return;
      }
      // 展示电话信息卡片
      // 如果是 打码号码 需要先请求接口获取真实号码
      let phoneMap = this.virtualPhone[item.type];
      if (!phoneMap.protected || phoneMap.isLoad) {
        this.phoneMap = phoneMap;
        this.phoneMap.showMask = true;
        fn && fn()
        return;
      }
      this.itemLoading = true;
      let phone = Encrypt(this.phone);

      this.getVirtualtelCall(phone, item.type, fn);
    },
    async getVirtualtelCall(phone, type, fn) {
      let roleMap = {
        1: 1, // 商家
        2: 0, // 骑手
      };
      let data = null;
      try {
        data = await api.getVirtualtelCall({
          orderId: this.orderId,
          phone: phone,
          callingCode: this.callingCode,
          role: roleMap[type], // 0 骑手 1 商家
        });
      } catch (err) {
        this.$utils.warningToast(err?.errmsg || 'Error');
      }
      this.itemLoading = false;
      if (!data) return;
      let virtualPhone = Decrypt(data.virtualPhone);
      this.virtualPhone[type].phone = virtualPhone;
      this.virtualPhone[type].isLoad = true;
      this.phoneMap = this.virtualPhone[type];
      this.phoneMap.showMask = true;
      fn && fn()
    },
    phoneCardShow(item) {
      let show = !this.isH5 && this.phoneMap.showMask && this.phoneMap.type === +item.type
      show && this.$trackEvent({
        eventId: 'sailing_c_x_orderdetail_contact_sw',
        eventLabel: '联系商家骑手电话号曝光',
        attrs: {
          order_id: this.orderId,
          order_status: this.orderStatus,
          to_whom: this.phoneMap.type,
          entity_id: (item.type === 1
            ? this.detailData?.deliveryInfo?.riderId
            : this.detailData?.shopInfo?.shopId)
            || ''
        }
      })
      return show
    },
    mouseleave() {
      this.phoneMap.showMask = false
    },
    callPhone(item) {
      if (!item.isOpenPhone) return;
      // 拨打电话
      this.cardClick(item, () => {
        window.location.href = `tel:${this.phoneMap.phone}`;
      });
    },
  },
  destroyed() {
    eventBus.$off(ORDER_DETAIL_REFRESH);
  },
};
</script>
<style lang="scss" scoped>
.server-card-wrapper {
  display: flex;
  overflow: hidden;
}
.card-item {
  position: relative;
  flex: 1;
  padding: 12px 10px;
  min-width: calc(50% - 5px);
  background: #f8f8f8;
  border-radius: 4px;
}
.mask-opacity {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  opacity: 0;
}
.card-item:nth-child(even) {
  margin-left: 10px;
}
.item-img {
  width: 40px;
  height: 40px;
  object-fit: cover;
  border-radius: 50%;
}
.content-box {
  float: right;
  width: calc(100% - 48px);
  font-size: 0;
}
.item-title {
  margin-bottom: 4px;
  height: 18px;
  line-height: 18px;
  font-family: 'Aspira Light';
  font-weight: 200;
  font-size: 14px;
  color: #000000;
}

.item-tag {
  display: inline-block;
  padding: 0 4px;
  line-height: 16px;
  font-family: 'Aspira Light';
  font-weight: 200;
  font-size: 12px;
  color: #000000;
  background: #e3e3e6;
  border-radius: 2px;
}
.ellipsis {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  word-break: break-all;
  word-wrap: break-word;
}
.mb-right-box {
  display: none;
}
@media screen and (max-width: 768px) {
  .server-card-wrapper {
    white-space: nowrap;
    overflow-x: scroll;
  }
  .card-item {
    display: inline-block;
    margin-right: rem(18);
    padding: rem(26) rem(24);
    min-width: 88%;
    border-radius: rem(8);
    overflow: hidden;
  }
  .card-item:nth-child(even) {
    margin-left: 0;
  }
  .card-item:last-child {
    margin-right: 0;
  }
  .item-img {
    float: left;
    margin-right: rem(18);
    width: rem(88);
    height: rem(88);
  }

  .content-box {
    float: left;
    width: auto;
    max-width: 66%;
  }
  .item-title {
    margin-bottom: rem(2);
    height: rem(44);
    line-height: rem(44);
    font-size: rem(32);
  }
  .item-tag {
    padding: 0 rem(12);
    max-width: 100%;
    line-height: rem(36);
    font-size: rem(20);
    border-radius: rem(4);
  }
  .mb-right-box {
    display: block;
    float: right;
    margin-top: rem(20);
    font-size: rem(42);
  }
  .msg-btn,
  .phone-btn {
    display: inline-block;
    cursor: pointer;
  }
  .msg-btn {
    margin-left: rem(18);
    margin-right: rem(47);
  }
  .phone-btn {
    margin-left: rem(18);
  }
}
</style>
